<!-- PAGE CONTENT WRAPPER -->
<div class="page-content-wrap contentdata">
  <div class="row">
    <div class="col-md-12">
      <!-- breadcrumb -->
      <div class="page-breadcrumb">
        <ul class="page-breadcrumb__trail">
          <li><a>Reports</a></li>
          <li><a>Culture Summary</a></li>
        </ul>
        <div class="page-breadcrumb__icons">
          <a routerLink="/home/dashboard"><img
            src="assets/images/New_Icons/home-transprent-icon.svg" title="Home"></a></div>
      </div>
      <!-- breadcrumb End -->
      <!-- START FORM VALIDATION STATES -->
      <div class="block">
        <div class="page-header">
          <span class="page-header__title">Culture Summary</span>
        </div>
        <div class="Reports_form_div">
          <form class="form-horizontal" id="myForm" role="form" novalidate [formGroup]="registerForm">
            <div class="reports-form-container" (clickOutside)="isDropdownOpen = false">
              <mat-form-field appearance="outline" class="w-100 custom-select" *ngIf="isEmployee()">
                <mat-label>Business Name</mat-label>
                <!-- search box powered by mat‑autocomplete -->
                <input matInput type="text" id="businessname" autocomplete="off" formControlName="businessfield"
                       placeholder="Search business" (keyup)="filterBusinesses($event)"
                       (click)="isDropdownOpen = true" (focus)="filteredOptions = businessEntities"
                       [matAutocomplete]="businessAuto"/>
                <mat-autocomplete #businessAuto="matAutocomplete" (optionSelected)="selectOption($event.option.value)">
                  <mat-option *ngFor="let option of filteredOptions" [value]="option">
                    {{ option.businessName }}
                  </mat-option>
                </mat-autocomplete>
                <mat-hint *ngIf="f.businessfield.invalid"><i>Select business</i></mat-hint>
                <mat-hint *ngIf="f.businessfield.valid"><i>Business selected</i></mat-hint>
                <mat-error
                  *ngIf="(submitted || f.businessfield.touched || f.businessfield.dirty) && f.businessfield.errors">
                  <i *ngIf="f.businessfield.hasError('required')">Required.</i>
                </mat-error>
              </mat-form-field>
              <mat-form-field appearance="outline" class="w-100" *ngIf="isProviderManager()">
                <mat-label>Technician</mat-label>
                <mat-select id="businessfield" formControlName="businessfield" name="businessfield"
                            (click)="isDropdownOpen = false"
                            [(ngModel)]="cultureSummaryReport.person_id"
                            (selectionChange)="getFarmSitesByTechnicianId()">
                  <mat-option value="undefined" disabled>Select Technician</mat-option>
                  <mat-option *ngFor="let tech of persons" [value]="tech.id">
                    {{ (tech?.firstName) }} {{ tech.lastName }}
                  </mat-option>
                </mat-select>
                <mat-hint *ngIf="f.businessfield.invalid"><i>Select technician</i></mat-hint>
                <mat-hint *ngIf="f.businessfield.valid"><i>Technician selected</i></mat-hint>
                <mat-error
                  *ngIf="(submitted || f.businessfield.touched || f.businessfield.dirty) && f.businessfield.errors">
                  <i *ngIf="f.businessfield.hasError('required')">Required.</i>
                </mat-error>
              </mat-form-field>
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Farm Site</mat-label>
                <mat-select id="location" formControlName="locationField" name="location"
                            [(ngModel)]="cultureSummaryReport.farm_site_id">
                  <mat-option value="undefined" disabled>Select Farm site</mat-option>
                  <mat-option *ngFor="let farmsite of farmSites" [value]="farmsite.id">
                    {{ (farmsite?.farmNameAtLocation) }}
                  </mat-option>
                </mat-select>
                <mat-hint *ngIf="f.locationField.invalid"><i>Select farm site</i></mat-hint>
                <mat-hint *ngIf="f.locationField.valid"><i>Farm site selected</i></mat-hint>
                <mat-error
                  *ngIf="(submitted || f.locationField.touched || f.locationField.dirty) && f.locationField.errors">
                  <i *ngIf="f.locationField.hasError('required')">Required.</i>
                </mat-error>
              </mat-form-field>
            </div>
          </form>
          <div class="buttons-div reports_search_div">
            <div class="transactions-button-container" (click)="cultureSummary()">
              <button class="transaction-submit-button" [disabled]="submitButtonDisabled">
                <span class="icon"><img src="../../../../../../assets/images/New_Icons/search-icon.svg"></span>
                <span class="text">Search</span>
              </button>
            </div>
          </div>
          <div *ngIf="responseLoader">
            <div class="adjust">
              <div class="reports-loader"></div>
            </div>
          </div>
        </div>
        <div class="reports_block"
             *ngIf="!responseLoader && isSubmitClicked && originalcultureSummaryReports?.length > 0">
          <div class="actions-container">
            <div class="search-div">
              <img src="assets/images/New_Icons/search-icon.svg">
              <input type="text" (keyup)="onFiltersApplied('Search')" [(ngModel)]="search" name="search"
                     autocomplete="off" placeholder="Search by section, pond, hatchery, brood and brood line names">
              <button *ngIf="this.search != ''" type="button" (click)="clearFilters('search')" title="clear search"
                      class="searchClose">&times;
              </button>
            </div>
            <div class="action-icons" *ngIf="cultureSummaryReports?.length > 0">
              <img src="assets/images/New_Icons/excel-download-icon.svg" title="Excel downlaod" (click)="exportExcel()">
              <img src="assets/images/New_Icons/expand-icon.svg" title="Zoom in" (click)="openFullScreen()">
            </div>
          </div>
          <div class="table-responsive" id="zoomView" *ngIf="cultureSummaryReports?.length > 0">
            <table class="table table-bordered table-responsive-md table-striped">
              <thead>
              <tr>
                <th></th>
                <th colspan="6">Culture Details</th>
                <th colspan="4">Pond Details</th>
                <th colspan="5">Production</th>
                <th colspan="4">Feed Consumption</th>
                <th>Charts</th>
              </tr>
              <tr>
                <th>S.NO</th>
                <th>Section</th>
                <th (click)="sortingTanks('pondname')" class="handSymbol">Pond Name
                  <span class="glyphicon sort-icon"
                        [ngClass]="{'glyphicon-chevron-up':nameAsc,'glyphicon-chevron-down':!nameAsc}"></span>
                </th>
                <th (click)="sortingTanks('identifier')" class="handSymbol">Culture Identifier
                  <span class="glyphicon sort-icon"
                        [ngClass]="{'glyphicon-chevron-up':cultureIdentifierAsc,'glyphicon-chevron-down':!cultureIdentifierAsc}"></span>
                </th>
                <th (click)="sortingTanks('startdate')" class="handSymbol">Culture Start Date
                  <span class="glyphicon sort-icon"
                        [ngClass]="{'glyphicon-chevron-up':startDateAsc,'glyphicon-chevron-down':!startDateAsc}"></span>
                </th>
                <th (click)="sortingTanks('enddate')" class="handSymbol">Culture End Date
                  <span class="glyphicon sort-icon"
                        [ngClass]="{'glyphicon-chevron-up':endDateAsc,'glyphicon-chevron-down':!endDateAsc}"></span>
                </th>
                <th>Days of Culture(DOC)</th>
                <th>Hatchery Name</th>
                <th>Brood</th>
                <th>Brood Line</th>
                <th (click)="sortingTanks('stockingsize')" class="handSymbol">Stocking Size
                  <span class="glyphicon sort-icon"
                        [ngClass]="{'glyphicon-chevron-up':stockingSizeAsc,'glyphicon-chevron-down':!stockingSizeAsc}"></span>
                </th>
                <th>Pond Size</th>
                <th>Density</th>
                <th>Count</th>
                <th>ABW</th>
                <th>Total Biomass</th>
                <th>No. Of Animals</th>
                <th>Survival at Harvest(%)</th>
                <th>Cumulative Feed(Kgs)</th>
                <th>FCR</th>
                <th></th>
              </tr>
              </thead>
              <tbody>
              <tr
                *ngFor="let list of cultureSummaryReports; let i = index">
                <td>{{ i + 1 }}</td>
                <td>{{ list.section_name }}</td>
                <td>{{ list.name }}</td>
                <td>{{ list.culture_identifier_x }}</td>
                <td>{{ list.culture_start_date | date:"dd MMM yyyy" }}</td>
                <td>{{ list.culture_end_date | date:"dd MMM yyyy" }}</td>
                <td class="number-align-right">{{ list.Age_of_culture }}</td>
                <td>{{ list.Hatcheryname == null ? '--' : list.Hatcheryname }}</td>
                <td>{{ list.breeder_name == null ? '--' : list.breeder_name }}</td>
                <td>{{ list.breed_line_name == null ? '--' : list.breed_line_name }}</td>
                <td class="number-align-right">{{ list.stocking_count | currencyFormat }}</td>
                <td class="number-align-right">{{ list.pond_size | currencyFormat }}</td>
                <td class="number-align-right">{{ list.density | currencyFormat }}</td>
                <td class="number-align-right">{{ list.count | currencyFormat }}</td>
                <td class="number-align-right">{{ list.abw | currencyFormat }}</td>
                <td class="number-align-right">{{ list.harvest_weight | currencyFormat }}</td>
                <td class="number-align-right">{{ list.no_of_animals | currencyFormat }}</td>
                <td class="number-align-right">{{ list.SurvivalRate | currencyFormat }}</td>
                <td class="number-align-right">{{ list.cf | currencyFormat }}</td>
                <td class="number-align-right">{{ list.fcr == null ? 'NA' : list.fcr | currencyFormat }}</td>
                <td class="viewgraph"
                    (click)="diffFeedlogvsDOc(list && list.farm_site_id,list && list.PondID, list && list.PondCultureID)"
                    data-toggle="modal" data-target="#cultureSummaryGraph" data-backdrop="static" data-keyboard="false">
                  View
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <div *ngIf="listLoader" class="loader-div">
            <div class="adjust">
              <div class="loader2 list-loader"></div>
            </div>
          </div>
          <div *ngIf="cultureSummaryReports?.length <= 0" class="noDataFoundMessage">
            {{ 'No items match your search' }}
          </div>
        </div>
        <div class="reports_block" *ngIf="(originalcultureSummaryReports?.length == 0) && isSubmitClicked">
          <div class="noDataFoundMessage">Data Not Available</div>
        </div>
      </div>
      <!-- END FORM VALIDATION STATES -->

      <!--culture Summary details modal popup-->
      <div class="modal fade" id="cultureSummaryGraph" role="dialog">
        <div class="modal-dialog modal-lg culturebody">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" title="Close Popup" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body culturegraph">
              <div class="block">
                <div class="row">
                  <h4 style="color: #000; padding: 10px;">Pond Name:
                    {{ pondCulture && pondCulture.feedlogs[0] && pondCulture.feedlogs[0].pondName }}</h4>
                  <div class="col-md-7">
                    <!--<div *ngIf="myChartNodata">No data</div>
                    <div *ngIf="!myChartNodata" style="height:370px">-->
                    <!--<canvas id="myChart"></canvas>-->
                    <!--</div>-->
                    <div class="x_chart_panel">
                      <div *ngIf="myChartNodata">No Feedlog vs DOC data</div>
                      <div [hidden]="myChartNodata" class="x_content">
                        <canvas id="myChart"></canvas>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5" *ngIf="!myChartNodata">
                    <div class="panel panel-default">
                      <div class="panel-body table-responsive totalfarmermodelscrollbar" id="style-4"
                           style="max-height: 340px;">
                        <table class="table table-striped table-hover">
                          <thead>
                          <tr>
                            <th>DATE</th>
                            <th>FEED GIVEN(gms)</th>
                            <th>DOC</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr *ngFor="let list of pondCulture && pondCulture.feedlogs">
                            <td>{{ list.Date | date:"dd-MMM-yyyy" }}</td>
                            <td>{{ list.feedGiven == null ? '-NA-' : list.feedGiven }}</td>
                            <td>{{ list.DOC }}</td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
                <!--Sampling vs doc charts-->
                <div class="row">
                  <div class="col-md-7">
                    <!--<div *ngIf="mySamplingvsDocData">No data</div>
                    <div *ngIf="!mySamplingvsDocData" style="height:500px">
                      <canvas id="samplingChart"></canvas>
                    </div>-->
                    <div class="x_chart_panel">
                      <div *ngIf="mySamplingvsDocData">No ABW vs DOC data</div>
                      <div *ngIf="!mySamplingvsDocData" class="x_content">
                        <canvas id="samplingChart"></canvas>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5" *ngIf="!mySamplingvsDocData">
                    <div class="panel panel-default">
                      <div class="panel-body table-responsive totalfarmermodelscrollbar" id="style-4"
                           style="max-height: 370px;">
                        <table class="table table-striped table-hover">
                          <thead>
                          <tr>
                            <th>ABW(gms)</th>
                            <th>ADG(gms)</th>
                            <th>DOC</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr *ngFor="let list of pondCulture && pondCulture.samplings">
                            <td>{{ list.ABW }}</td>
                            <td>{{ list.ADG }}</td>
                            <td>{{ list.Doc }}</td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer ambrolive-popup-close">
              <button class="center-block submitbtn" data-dismiss="modal" type="submit">
                <img src="assets/images/New_Icons/close.svg">Close
              </button>
            </div>
          </div>
        </div>
      </div>
      <!--culture summary modal popup end-->
    </div>
  </div>
</div>
<!-- END PAGE CONTENT WRAPPER -->
<!-- END PAGE CONTENT WRAPPER -->
